import React from 'react';
import { Routes, Route } from "react-router-dom";
import AdminListingList from "./admin-listing-list/admin-listing-list";
import AdminListingDetails from "./admin-listing-details/admin-listing-details";

const AdminListing = () => {
  return (
    <Routes>
      <Route index element={<AdminListingList />} />
      <Route path=":applicationId" element={<AdminListingDetails />} />
    </Routes>
  )
}

export default AdminListing;
